import { render, staticRenderFns } from "./logoNameImg.vue?vue&type=template&id=2b7219b5&scoped=true"
import script from "./logoNameImg.vue?vue&type=script&lang=js"
export * from "./logoNameImg.vue?vue&type=script&lang=js"
import style0 from "./logoNameImg.vue?vue&type=style&index=0&id=2b7219b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7219b5",
  null
  
)

export default component.exports